<div class="experienceCards merchandiseCards">
  <div class="row">
    <div [class]="colClass" *ngFor="let _ of cardIndices">
      <div class="skeleton-card">
        <div class="skeleton-media">
          <app-skeleton className="h-100% w-100% r-8 c-sbg hard"></app-skeleton>
        </div>
        <div class="skeleton-copy">
          <app-skeleton className="h-16 w-80% r-6 c-post"></app-skeleton>
          <app-skeleton className="h-14 w-48% r-6 c-post"></app-skeleton>
        </div>
      </div>
    </div>
  </div>
</div>
